module.exports = __webpack_public_path__ + "img/view-arrow.49b54909.svg";